module.exports = __webpack_public_path__ + "img/line1.9d738624.svg";